const wrapper = "_275w1xi6jyx";

export { wrapper };
import "./molecule.group.style.linaria.module.css";
//# sourceMappingURL=molecule.group.style.js.map
